function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M282.087 150.851C258.497 150.851 238.084 143.098 220.904 128.002C204.735 113.696 200.516 89.852 210.762 70.6921L210.859 70.52L172.124 136.034L171.022 137.943C187.089 167.521 217.65 185.877 250.828 185.877C284.006 185.877 314.567 167.521 330.634 137.943C316.406 143.885 299.894 150.851 282.087 150.851Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M315.336 27C315.432 35.6789 317.58 43.9561 317.58 52.8891C317.58 86.5473 292.647 121.05 275.033 132.187C258.039 142.992 236.113 141.222 221 127.827C251.26 155.812 296.097 159.868 330.722 137.752C350.398 101.468 344.122 56.2941 315.336 27Z",
  fill: "url(#paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M226.389 21.9137C264.996 21.9137 295.76 57.5634 296.411 91.4757V92.9345C296.415 108.972 288.296 123.875 274.937 132.354C310.091 110.546 326.591 67.4753 315.232 27.1669C294.892 6.49087 266.181 -3.21216 237.746 0.980559C209.311 5.17328 184.477 22.7717 170.724 48.4748L169.461 50.6138C186.641 36.3949 202.775 21.9137 226.389 21.9137Z",
  fill: "url(#paint2_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M250.8 46.4669C226.671 45.1803 200.13 64.4967 184.164 75.6915L164.861 90.2382C159.698 93.8605 126.046 123.265 122.732 126.494C105.617 143.198 78.7942 143.746 61.0349 127.756C77.2495 142.877 98.9091 153.654 122.628 153.654C140.427 153.654 159.561 151.539 170.998 137.935L172.1 136.017L210.835 70.5448L210.738 70.7169C218.731 55.7889 234.087 46.5006 250.776 46.4997",
  fill: "url(#paint3_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M122.74 126.503C126.367 123.946 159.971 94.1313 165.126 90.5172L184.429 76.0033C200.419 64.833 227.765 45.9838 250.8 46.5001C275.937 46.5 296.333 67.2307 296.395 92.8447V91.5088C296.4 60.4828 276.672 33.0314 247.642 23.6694C218.613 14.3074 186.976 25.1941 169.461 50.5731L131.12 115.406C128.674 119.355 125.871 123.061 122.748 126.478",
  fill: "url(#paint4_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M171.006 137.935C136.269 160.097 91.2911 155.934 61.0424 127.757C44.5675 112.946 40.8039 88.2683 52.0906 69.0615C40.8304 78.6009 36.3746 99.8104 36.3746 117.594C36.3746 142.402 45.624 171.749 63.7689 181.567C105.148 194.829 149.972 176.591 171.006 137.935Z",
  fill: "url(#paint5_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.6832 117.569C38.6573 100.447 43.299 83.6534 52.0908 69.0613C63.8406 49.069 88.3058 41.0363 109.3 50.2776C101.386 40.353 84.1822 39.3286 70.1553 39.3286C43.2436 39.3286 16.4042 49.0975 2.32909 72.0526C-8.31444 119.304 18.4407 166.963 63.8094 181.567C47.6644 164.323 38.665 141.402 38.6832 117.569Z",
  fill: "url(#paint6_linear)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M75.0488 43.6722C84.8357 43.6693 94.5588 45.2772 103.843 48.4337C105.813 49.1385 106.69 49.4827 108.717 50.3514C110.896 51.3676 112.247 51.9905 116.39 54.3589C127.136 60.2991 140.569 56.5348 146.823 45.8303C153.077 35.1259 149.921 21.2997 139.674 14.505C114.692 -1.67625 83.5564 -4.49713 56.1644 6.93902C28.7723 18.3752 8.53091 42.6457 1.87401 72.0363C1.00225 75.9113 0.376285 79.8395 0 83.7966C17.0142 58.6553 45.0775 43.6514 75.0488 43.6722Z",
  fill: "url(#paint7_linear)"
});

var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 230.521,
  y1: 128.189,
  x2: 338.388,
  y2: 128.189,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C800CA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7D25CF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 325.677,
  y1: 16.7208,
  x2: 275.335,
  y2: 134.836,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#003FBF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.07,
  stopColor: "#1E39C3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#3B33C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#532ECA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#662ACC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#7327CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#7B25CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7D25CF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 170.312,
  y1: 31.3197,
  x2: 303.577,
  y2: 77.8122,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#038FF4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2,
  stopColor: "#0278E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#0159D0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.81,
  stopColor: "#0046C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#003FBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 138.11,
  y1: 113.802,
  x2: 256.613,
  y2: 9.91789,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#43B64E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#40B555"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#38B16A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#2CAB8C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  stopColor: "#1AA3BB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#0498F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0398F9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 77.9953,
  y1: 84.3208,
  x2: 265.664,
  y2: 62.6604,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#038FF4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#038DF2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#0384EB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.98,
  stopColor: "#0376DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0375DD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 55.2131,
  y1: 138.19,
  x2: 155.229,
  y2: 96.016,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFCC00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#FACB02"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#EDCA07"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#D7C711"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#B7C41E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#8FBF2F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.92,
  stopColor: "#5EB943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#43B64E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 65.7646,
  y1: 190.106,
  x2: 53.0552,
  y2: 56.7898,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFCC00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 2.16981,
  y1: 41.4264,
  x2: 150.124,
  y2: 43.0679,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#FF9800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C42222"
})));

function SvgWecoDepartmentsNavigation(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 186,
    viewBox: "0 0 343 186",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

export default "data:image/svg+xml;base64,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";
export { SvgWecoDepartmentsNavigation as ReactComponent };